
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Aluminiuamlglass() {



  const cardData =
  {
    keyword: ' Aluminium Glass Office Partition Services ',
    heading: 'Anjali Enterprises: Aluminium Glass Office Partition Services ',
    headingDescription: 'When it comes to reliable and innovative office partition solutions in Pune, Anjali Enterprises is your trusted partner. Our services are designed to transform workspaces into modern, functional, and aesthetically pleasing environments. Whether you need sleek aluminium glass partitions, soundproofing solutions, or durable partition walls, we deliver exceptional results tailored to your specific needs. With high-quality materials, expert craftsmanship, and a commitment to customer satisfaction, Anjali Enterprises ensures that your office space reflects professionalism, comfort, and style.',

    topPlaces: [
      {
        title: "All Types of Aluminium Glass Office Partition",
        description: "Create modern and functional office spaces with Anjali Enterprises, your trusted partner for aluminium glass office partitions. We provide top-quality partitioning solutions designed to meet diverse business needs while enhancing workspace aesthetics and functionality. Whether you require soundproofing, sleek designs, or durable structures, we have the expertise to deliver outstanding results."
      },
      {
        title: "Aluminium Glass Partition",
        description: "Elevate your office environment with our aluminium glass partitions, combining durability with a sophisticated look. Our partitions are ideal for dividing spaces while maintaining an open, light-filled ambiance."
      },
      {
        title: "Office Glass Partition Installation",
        description: "Our professional team specializes in the seamless installation of office glass partitions. We ensure precision, timely execution, and a flawless finish that aligns with your office design."
      },
      {
        title: "Glass Partition for Offices in Pune",
        description: "For businesses in Pune, we provide high-quality glass partitions that balance functionality and elegance. These partitions are perfect for creating a professional and modern workspace that reflects your brand’s identity."
      },
      {
        title: "Office Room Divider Glass",
        description: "Transform your office with our room divider glass solutions. These are designed to create distinct areas while maintaining an open and collaborative atmosphere."
      },
      {
        title: "Aluminium Partitioning for Offices",
        description: "Our aluminium partitioning solutions are known for their durability, sleek appearance, and adaptability to various office layouts. They are a cost-effective way to create functional workspaces."
      },
      {
        title: "Partitioning Solutions",
        description: "At Anjali Enterprises, we offer comprehensive partitioning solutions to suit every business need. From private cabins to collaborative areas, our partitions cater to a wide range of requirements."
      },
      {
        title: "Best Office Partitions in Pune",
        description: "Our dedication to quality and craftsmanship makes us the provider of the best office partitions in Pune. Each project is executed with precision and care to exceed client expectations."
      },
      {
        title: "Aluminium Framed Glass Office Partition",
        description: "Enhance the modern aesthetic of your office with aluminium-framed glass partitions. These partitions provide a contemporary look while ensuring durability and practicality."
      },
      {
        title: "Modern Office Partitions",
        description: "Stay ahead with modern office partitions that combine innovative designs, high functionality, and premium materials. Our solutions are ideal for creating cutting-edge workspaces."
      },
      {
        title: "Partition Wall Installation",
        description: "Our expert installation team ensures that partition walls are installed efficiently, maintaining structural integrity and aesthetic appeal. We work closely with clients to create the perfect office layout."
      },
      {
        title: "Pune Office Glass Partition Service",
        description: "As one of Pune’s leading providers of office glass partitions, we are known for our exceptional service, quality materials, and innovative designs."
      },
      {
        title: "Glass Partition Work in Pune",
        description: "From consultation to installation, our glass partition work in Pune is designed to deliver superior results that transform your office space."
      },
      {
        title: "Premium Office Partitions",
        description: "Our premium office partitions are crafted from top-quality materials and are designed to last. These partitions enhance the overall workspace experience, ensuring comfort and style."
      },
      {
        title: "Soundproof Glass Partitions",
        description: "Achieve peace and privacy in your office with our soundproof glass partitions. Ideal for meeting rooms and executive offices, these partitions combine aesthetics with practicality."
      },
      {
        title: "Glass Partition Contractors Pune",
        description: "Anjali Enterprises is a trusted name among glass partition contractors in Pune. Our commitment to quality, affordability, and timely delivery makes us the preferred choice for businesses across the city."
      },
      {
        title: "Anjali Enterprises Contact Number: ",
        description: "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality aluminium glass office partitions. We specialize in creating stylish and durable partitions for all types of office spaces, ensuring both privacy and aesthetics. Get in touch for a seamless installation experience and professional service."
      }
    ],
    tableData: [
      ["- Aluminium glass partition", "- Office glass partition installation"],
      ["- Glass partition for offices in Pune", "- Office room divider glass"],
      ["- Aluminium partitioning for offices", "- Partitioning solutions"],
      ["- Best office partitions in Pune", "- Aluminium framed glass office partition"],
      ["- Modern office partitions", "- Partition wall installation"],
      ["- Pune office glass partition service", "- Premium office partitions"],
      ["- Soundproof glass partitions", "- Glass partition contractors Pune"]
    ],


    "whychoose": [
      {
        "WhyChooseheading": "Expertise in Office Partitions",
        "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing high-quality aluminium glass office partitions. Our team has years of experience in designing, manufacturing, and installing partitions that enhance the aesthetics and functionality of your office space."
      },
      {
        "WhyChooseheading": "Customized Solutions",
        "WhyChoosedescription": "We understand that every office has unique requirements. That's why we offer customized aluminium glass partitions that fit your space, needs, and budget. Whether it's for privacy, space optimization, or modern design, we provide solutions tailored just for you."
      },
      {
        "WhyChooseheading": "Durability and Quality",
        "WhyChoosedescription": "We use only the finest quality materials to ensure that our partitions are long-lasting, durable, and resilient. Our aluminium frames and glass are designed to withstand daily wear and tear, providing a lasting investment for your office."
      },
      {
        "WhyChooseheading": "Timely Delivery and Installation",
        "WhyChoosedescription": "At Anjali Enterprises, we value your time. We offer prompt and efficient installation services, ensuring that your office partitions are set up with minimal disruption to your business operations."
      },
      {
        "WhyChooseheading": "Affordable Pricing",
        "WhyChoosedescription": "We provide top-notch aluminium glass partitions at competitive prices. With transparent pricing and no hidden charges, we ensure you get the best value for your investment in office design."
      },
      {
        "WhyChooseheading": "Professional Team",
        "WhyChoosedescription": "Our experienced and skilled team handles everything from the initial design consultation to the final installation. We work closely with you to understand your needs and deliver a professional, hassle-free service."
      },
      {
        "WhyChooseheading": "Customer Satisfaction",
        "WhyChoosedescription": "We are committed to delivering excellent customer service. With numerous satisfied clients and repeat business, Anjali Enterprises strives to exceed your expectations with every project we undertake."
      }
    ]


  }

  const faqData = [
    {
      question: "What types of aluminium glass office partitions do you offer?",
      answer: "We offer a wide range of aluminium glass partitions, including framed, frameless, sliding, and fixed partitions, tailored to your specific office needs."
    },
    {
      question: "Can you customize the design of the partitions?",
      answer: "Yes, all our office partitions can be customized to meet your design preferences and spatial requirements, ensuring that they align with your office’s aesthetic and functional goals."
    },
    {
      question: "How long does the installation process take?",
      answer: "The installation time depends on the scope of the project. However, we ensure timely and efficient installation, typically completing most projects within a few days."
    },
    {
      question: "Is there a warranty on your partitions?",
      answer: "Yes, we provide a warranty on all our aluminium glass office partitions, ensuring peace of mind and long-term durability."
    },
    {
      question: "How do I get a quote for office partition installation?",
      answer: "You can contact us directly for a free consultation and quote. We assess your office space and provide an accurate, transparent estimate based on your requirements."
    },
    {
      question: "Are your office partitions easy to maintain?",
      answer: "Yes, our aluminium glass partitions are easy to maintain. We use high-quality materials that are resistant to wear, making them easy to clean and maintain over time."
    },
    {
      question: "Can you install partitions in existing office spaces?",
      answer: "Yes, we specialize in retrofitting partitions in existing office spaces, ensuring minimal disruption to your ongoing operations."
    },
    {
      question: "Do you provide partition solutions for large offices?",
      answer: "Absolutely! Whether it’s a small office or a large corporate space, we offer partition solutions for offices of all sizes."
    },
    {
      question: "Can I get a design consultation for my office?",
      answer: "Yes, we offer free design consultations to help you choose the best partition solution for your office space, considering both aesthetics and functionality."
    },
    {
      question: "What makes Anjali Enterprises different from other partition suppliers?",
      answer: "Anjali Enterprises stands out for our commitment to quality, customer satisfaction, and timely delivery. We combine superior materials with expert installation to provide partition solutions that enhance your office environment."
    }
  ];

  const testimonials = [
    {
      name: "Mr. Rakesh Sharma",
      text: "Anjali Enterprises provided us with the perfect aluminium glass partitions for our office. The installation was quick, and the partitions not only look great but also create a more efficient working space. Highly recommend their services!"
    },
    {
      name: "Ms. Neha Kapoor",
      text: "We were looking for a modern partition design for our office, and Anjali Enterprises delivered exactly what we wanted. The quality of the materials is excellent, and the installation team was professional and prompt. A fantastic experience!"
    }
  ];



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>

<Helmet>
  <title>Aluminium Glass Office Partition Services in Pune | Anjali Enterprises </title>
  <meta name="description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta name="keywords" content="Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services" />
  <meta property="og:description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/office-partition-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-office-partition" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/office-partition-service.jpg",
        "priceRange": "₹1000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh T"
            },
            "datePublished": "2024-08-10",
            "reviewBody": "Anjali Enterprises did an excellent job with our office partition. The glass partition installation was smooth, and the final result looks amazing. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sanya M"
            },
            "datePublished": "2024-09-18",
            "reviewBody": "I am very pleased with the soundproof glass partitions they installed in our office. The quality and finishing are top-notch."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/aluminium-glass-office-partition"
        },
        "keywords": "Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune"
      }
    `}
  </script>
</Helmet>




      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/1.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Aluminiuamlglass;